import { render } from "./WeddingMap.vue?vue&type=template&id=509ac7ad&scoped=true"
import script from "./WeddingMap.vue?vue&type=script&lang=js"
export * from "./WeddingMap.vue?vue&type=script&lang=js"

import "./WeddingMap.vue?vue&type=style&index=0&id=509ac7ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509ac7ad"]])

export default __exports__